/**
 * Conecta con la API del backend
 */
export const API_BASE_URL = `https://api-v2.quimica.unam.mx/sicpa/api/`
